export default __webpack_public_path__ + "static/media/20.4fdf13ee.jpg";